export default {
  UPDATE_UNREADCOUNT (state, unReadCount) {
    state.unReadCount = unReadCount;
  },
};
